
/**
 * Handle the scrolling of anchors
 */
DO.Subscribe('app:ready', function(e, $) {
	'use strict';

	/**
	 * ignore any links with this selector
	 * @type {string}
	 */
	var exemptionList =
			'[data-switch], [data-toggle], [data-toggle-remove], [role="button"], [data-preventdefault], [data-noanchor], [data-href], [data-target]';

	function init() {
		setup($(document));
		loadAnchor();
	}

	function setup(scope) {
		attachEvents(scope);
	}

	function attachEvents(scope) {
		scope
			.find('a[href*="#"]')
			.not(exemptionList)
			.on('click', function(e) {
				e.stopPropagation();
				handleClick(this, e);

				if ($(this).data('trigger-click')) {
					handlerTriggerClick();
				}
			});

		if (scope.is(document)) {
			$(document).on('ajaxpages:contentloaded', function(e, data) {
				setup(data.target);
			});
		}
	}

	function handlerTriggerClick() {
		var target = $(this).data('trigger-click');
		$(target).trigger('click');
	}

	/**
	 * Load an anchor supplied on page load
	 * @returns {null}
	 */
	function loadAnchor() {
		var urlHash = window.location.hash.substr(1),
			target;

		if (urlHash !== '') {
			target = $('#' + urlHash);
			handleAnchors(target);
		}

		return null;
	}

	function handleClick(self, e) {
		var href = $(self).attr('href'),
			id = href.split('#')[1],
			target = $('#' + id),
			samePage = href.split('#')[0] === window.location.pathname;

		if (samePage && target.length > 0) {
			// this is a link to this page
			e.preventDefault();
			handleAnchors(target);
		}
	}
	/**
	 * Handle anchor specific actions
	 * @param target
	 */
	function handleAnchors(target) {
		if (target.length < 1) {
			return;
		}

		var el = handleAccordion(target);

		// Give the browser time to get ready
		setTimeout(function() {
			var isMobile = ['xs', 'sm', 'md'].indexOf(DO.CurrentBreakpoint()) > -1,
				mobileScrollDiff = DO.CurrentBreakpoint() === 'md' ? -200 : -154,
				behavior = isMobile ? 'instant' : 'smooth'; // smooth scrolling won't work if we have to manipulate the position afterwards

			if ($('html.ie').length > 0) {
				el[0].scrollIntoView(true); // IE11 only support this syntax, no smooth scrolling
			} else {
				el[0].scrollIntoView({
					behavior: behavior,
					block: 'start',
					inline: 'nearest'
				});
			}

			if (isMobile) {
				window.scrollBy(0, mobileScrollDiff); // adjust for the sticky headers (need to calculate)
			}

			el.focus();
		}, 500);
	}

	/** *
	 * if this is a link to an accordion item, we want to make the trigger fire an event to open
	 * @param target
	 * @returns {*}
	 */
	function handleAccordion(target) {
		const accordion = target.closest('[data-toggle-item-accordion]');

		if (accordion) {
			if (!accordion.data('toggle-item-accordion') || accordion.hasClass('active')) {
				return target;
			}
		}

		let el = $(accordion).find('[data-accordion-trigger]').first(),
			ie = navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0,
			event = ie ? document.createEvent('Event') : new Event('click');

		if (ie) {
			event.initEvent('click', true, true);
			el[0].dispatchEvent(event);
		} else {
			el[0].dispatchEvent(event);
		}

		handleAnchors(target);
		return el;
	}

	init();
});


/**
 * The choices select component
 */

DO.Subscribe('app:ready', function(e, $) {
	'use strict';

	function init() {
		setup($(document));
	}

	function setup(scope) {
		if (scope.find('[data-choices]').length < 1) {
			return;
		}

		let formelements = scope.find('[data-choices]'),
			i;

		for (i = 0; i < formelements.length; i++) {
			attachChoices(formelements[i]);
		}

		applyLabels();
		attachEvents(scope);
	}

	function attachEvents(scope) {
		if (scope.is(document)) {
			$(document).on('ajaxpages:contentloaded', function(e, data) {
				setup(data.target);
			});
		}
	}

	function attachChoices(element) {
		let config = getChoicesConfig(element),
			choices = new Choices(element, config);

		if ($(element).data('ajax-search')) {
			attachAjax(element, choices);
		}

		attachAutoClose(choices, element);
		attachSubmit(choices, element);
	}

	function attachAjax(element, choices) {
		let delay = (function () {
			let timer = 0;
			return function (callback, ms) {
				clearTimeout(timer);
				timer = setTimeout(callback, ms);
			};
		})();

		element.addEventListener('search', function(e) {
			$(this).closest('.field').addClass('searchformdropdown--presearch');
			if (e.detail.keyCode === 13) {
				handleBackupSubmit($(this), e.detail.value);
			}
			let self = this;
			if (e.detail.value.length > 2) {
				delay(function () {
					doRequest(self, choices, e.detail.value);
				}, 300);
			}
		});

		$(element).on('afterSearch', function(e) {
			let input = $(this).siblings('input');
			setTimeout(function() {
				input.focus();
			}, 500);
		});

		if ($(element).attr('placeholder')) {
			applyPlaceholderToSearch(element);
		}
	}

	function applyPlaceholderToSearch(element) {
		let placeholder = $(element).attr('placeholder'),
			input = $(element).siblings('input');

		input.attr('placeholder', placeholder);
	}

	/**
	 * This function handles manually submitting a search field with an ajax submit
	 * It relies on a hidden field to store the value of the search criteria
	 */
	function handleBackupSubmit(self, value) {
		let form = self.closest('form'),
			id = self.attr('id'),
			bkField = $('[data-choices-bkfieldfor="#' + id + '"]');

		if (bkField.length < 1) {
			console.log('No manual submit available'); // No hidden field set up
			return;
		}

		bkField.val(value);
		form.trigger('submit');
	}

	function doRequest(element, choices, value) {
		let name = $(element).attr('name'),
			url = $(element).data('ajax-search') + '?' + name + '=' + value + '&ajax=true';

		choices.setChoices(async () => {
			try {
				let items = await fetch(url);
				$(element).closest('.field').removeClass('searchformdropdown--presearch');
				$(element).trigger('afterSearch', {target: element});
				return items.json();
			} catch (err) {
				$(element).closest('.field').removeClass('searchformdropdown--presearch');
				console.error(err);
			}
		}, 'value', 'label', true);
	}

	function getChoicesConfig(element) {
		let placeholder = $(element).attr('placeholder') ? $(element).attr('placeholder') : null,
			hasSearch = $(element).data('ajax-search') || $(element).data('has-search'),
			maxitems = $(element).data('choices-maxitemcount') || -1,
			removeItems = $(element).data('canremove') !== 'undefined' && $(element).data('canremove');

		return {
			silent: false,
			items: [],
			choices: [],
			renderChoiceLimit: -1,
			maxItemCount: maxitems,
			addItems: true,
			removeItems: removeItems,
			removeItemButton: removeItems,
			editItems: false,
			duplicateItemsAllowed: true,
			delimiter: ',',
			paste: true,
			searchEnabled: hasSearch,
			searchChoices: true,
			searchFloor: 3,
			searchResultLimit: 10,
			searchFields: ['label', 'value'],
			position: 'auto',
			resetScrollPosition: true,
			shouldSort: false,
			shouldSortItems: false,
			placeholder: true,
			placeholderValue: placeholder,
			searchPlaceholderValue: null,
			prependValue: null,
			appendValue: null,
			renderSelectedChoices: 'auto',
			loadingText: 'Loading...',
			noResultsText: 'No results found',
			noChoicesText: '',
			itemSelectText: '',
			classNames: getClassNamesConfig(element)
		};
	}

	function getClassNamesConfig(element) {
		let prefix = $(element).data('choices-class') ? $(element).data('choices-class') : 'choices';

		return {
			containerOuter: prefix,
			containerInner: prefix + '-inner',
			input: prefix + '-input',
			inputCloned: prefix + '-input--cloned',
			list: prefix + '-list',
			listItems: prefix + '-list--multiple',
			listSingle: prefix + '-list--single',
			listDropdown: prefix + '-list--dropdown',
			item: prefix + '-item',
			itemSelectable: prefix + '-item--selectable',
			itemDisabled: prefix + '-item--disabled',
			itemChoice: prefix + '-item--choice',
			placeholder: prefix + '-placeholder',
			group: prefix + '-group',
			groupHeading: prefix + '-heading',
			button: prefix + '-button'
		};
	}

	function attachSubmit(choices, element) {
		if (!$(element).data('submitonchange')) {
			return;
		}

		$(element).on('change', function(e) {
			let value = e.detail.value;

			if (!value) {
				return;
			}

			this.closest('form').submit();
		});
	}

	function attachAutoClose(choices, element) {
		element.addEventListener('choice', function(e) {
			choices.hideDropdown();
		}, false);
	}

	function applyLabels() {
		let labelledSelects = $('select[aria-labelledby]'); // may need to exclude some formelements

		labelledSelects.each(function(index, el) {
			let select = $(this),
				label = select.attr('aria-labelledby');

			select.siblings('input').attr('aria-labelledby', label).attr('role', 'combobox');
			select.closest('.choices').find('[role="listbox"]').attr('aria-labelledby', label);
		});
	}

	init();
});

/**
 * Data slick slider init
 *
 */
DO.Subscribe('app:ready', function(e, $) {
	'use strict';

	function init() {
		if ($(document).find('[data-slider-statistics]').length < 1) {
			return;
		}

		var target = $(document).find('[data-slider-statistics]'),
			i;

		for (i = 0; i < target.length; i++) {
			let ss = $(target[i]);
			ss.slick(getConfig());

			$(window).on('resize', function() {
				if ($(window).width() < 1023 && !ss.hasClass('slick-initialized')) {
					ss.slick(getConfig());
				}
			});
		}
	}

	function getConfig() {
		return {
			mobileFirst: true,
			variableWidth: true,
			infinite: false,
			swipe: true,
			arrows: false,
			prevArrow: false,
			nextArrow: false,
			responsive: [
				{
					breakpoint: 1023,
					settings: 'unslick'
				}
			]
		};
	}

	init();
});

/**
 * Form field js
 */
DO.Subscribe('app:ready', function(e, $) {
	'use strict';

	function init() {
		setup($(document));
	}

	function setup(scope) {
		if (scope.find('form').length < 1) {
			return;
		}

		var i,
			inputs = scope.find('input.text');

		for (i = 0; i < inputs.length; i++) {
			applyActiveClasses($(inputs[i]));
			toggleActiveClass($(inputs[i]));
		}

		attachEvents(scope);
	}

	function applyActiveClasses(input) {
		if (input.val() === '') {
			input.removeClass('text--active');
		} else {
			input.addClass('text--active');
		}
	}

	function toggleActiveClass(input) {
		input.on('keyup', function() {
			applyActiveClasses($(this));
		});
	}

	function attachEvents(scope) {
		if (scope.is(document)) {
			$(document).on('ajaxpages:contentloaded', function(e, data) {
				setup(data.target);
			});
		}
	}

	init();
});

/**
 * Adjust height of insight iframes
 */
DO.Subscribe('app:ready', function(e, $) {
	'use strict';

	function init() {
		setup($(document));
	}

	function setup(scope) {
		if (scope.find('[data-insight]').length < 1) {
			return;
		}

		applyHeights(scope);
		attachEvents(scope);
	}

	function applyHeights(scope) {
		var insights = scope.find('[data-insight]'),
			i;

		for (i = 0; i < insights.length; i++) {
			applyHeightToInsight(insights[i]);
		}
	}

	function applyHeightToInsight(el) {
		var values = $(el).data('insight-height'),
			valueObj = values[0],
			height = valueObj[DO.CurrentBreakpoint()] === 'undefined' ? valueObj['base'] : valueObj[DO.CurrentBreakpoint()];

		// check size, grab size, apply
		$(el).height(height);
	}

	function attachEvents(scope) {
		// this bit is required for any components expected to load inside a dynamically fetched component
		// eg docks/slideout panels, lazy loaded accordions, dynamic results
		if (scope.is(document)) {
			$(document).on('ajaxpages:contentloaded', function(e, data) {
				setup(data.target);
			});

			DO.Subscribe(
				['app:breakpointchange'],
				function(e) {
					applyHeights(scope);
				}
			);
		}
	}

	init();
});

/**
*
* Mailchimp hide/show form
*/
DO.Subscribe('app:ready', function(e, $) {
    'use strict';

	/**
	 * Initialize Button actions
	 */
	function init() {
        setup($(document));
	}

    /**
	 * Apply setup to our newly loaded area (document, or scope)
	 *
	 * @param scope | DOMObject - the area of the page we are applying this functionality to
	 */
	function setup(scope) {
		bindEvents();
	}

    const formSection = $('.mail-chimp-element__form-section'),
        loader = $('.mail-chimp-element__loader'),
        iconMinus = $('.mail-chimp-element__icon-minus'),
        iconPlus = $('.mail-chimp-element__icon-plus'),
        submitButton = $('#Form_Form_action_process'),
        formSectionToggle = $('.mail-chimp-element__form-section--toggle'),
        button = $('.mail-chimp-element__button'),
        path = window.location.pathname.split('/').pop(),
        linkUrl = location.href.split('/'),
        url = linkUrl.slice(0, -3).join('/');

    submitButton.removeClass('action');

    if (path === 'error' || path === 'finished') {
        iconMinus.addClass('mail-chimp-element__icon--minus');
        iconPlus.hide();
        formSection.removeClass('mail-chimp-element__form-section--toggle');
        button.attr('disabled', 'disabled');
        button.css('cursor', 'not-allowed');
        $('.mail-chimp-element__link-button').attr('href', url);
    }

    formSectionToggle.removeClass('selector');
    formSection.addClass('success');

	function bindEvents() {
        $('#Form_Form_action_process').on('click', function () {
            loadSubscribe();
        });

        $('.mail-chimp-element__button').click(function() {
            toggleForm();
        });

        $('.mail-chimp-element__small-button').click(function() {
            closeForm();
        });
    }

    function closeForm() {
        formSectionToggle.slideToggle('fast');
        formSection.addClass('selector');
        iconMinus.toggleClass('mail-chimp-element__icon--minus');
        iconPlus.toggleClass('mail-chimp-element__icon--plus');
    }

    function toggleForm() {
        formSection.removeClass('selector');
        formSectionToggle.slideToggle('fast');
        iconMinus.toggleClass('mail-chimp-element__icon--minus');
        iconPlus.toggleClass('mail-chimp-element__icon--plus');
    }

    function loadSubscribe() {
        const form = $('#Form_Form'),
            url = form.attr('action'),
            data = form.serializeArray(),
            email = $('#Form_Form_Email').val(),
            emailValidation = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;

        if (emailValidation.test(email)) {
            form.hide();
            loader.css('visibility', 'visible');
            loader.show();
            loader.addClass('mail-chimp-element--loader');
            $.ajax({
                url: url,
                type: 'POST',
                data: data,
                dataType: 'text',
                success: function (html) {},
                error: function (response) {}
            });
        }
    }
	init();
});

/**
 * Javascript around controlling the main menu
 */
DO.Subscribe('app:ready', function(e, $) {
	'use strict';

	var focusable = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]',
		initScroll;

	function init() {
		setup($(document));
	}

	function setup(scope) {
		if (scope.find('[data-menu]').length < 1) {
			return;
		}

		attachEvents(scope);
	}

	function attachEvents(scope) {
		scope.find('[data-menu-show]').on('click', function() {
			initScroll = $(document).scrollTop();
			toggleMenu($(this));
			adjustView(scope, false);
		});

		scope.find('[data-close-menu]').on('click', function() {
			scope.find('[data-menu]').removeClass('menu--activesearch menu--activenav');
			adjustView(scope, true);
		});

		scope.find(focusable).on('keydown', function(e) {
			if ($(e.target).closest('[data-menu]').length > 0 && e.which === 9) {
				trapFocus(e);
			}
		});

		// this bit is required for any components expected to load inside a dynamically fetched component
		// eg docks/slideout panels, lazy loaded accordions, dynamic results
		if (scope.is(document)) {
			$(document).on('ajaxpages:contentloaded', function(e, data) {
				setup(data.target);
			});
		}
	}

	function getFirstFocus(scope) {
		var menu = scope.find('[data-menu]'),
			allFocus = menu.find(focusable).filter(':visible');

		return allFocus.first();
	}

	function toggleMenu(self) {
		var targetEl = self.data('menu-show'),
			targets = $(targetEl),
			value = self.data('menu-value-toggle'),
			valueRemove = self.data('menu-value-remove'),
			target,
			i;

		for (i = 0; i < targets.length; i++) {
			target = $(targets[i]);
			target.toggleClass(value);
			target.removeClass(valueRemove);
		}
	}

	function adjustView(scope, isClosing) {
		if (isClosing) {
			adjustViewHide(scope);
		} else {
			adjustViewShow(scope);
		}
	}

	function adjustViewShow(scope) {
		var body = $('body'),
			top = initScroll,
			first = getFirstFocus(scope);

		// Prevent disappearing scroll bars from interfering with smooth animation
		body.width(body.width());
		body.css('top', -top + 'px');
		first.focus();

		setTimeout(function() {
			body.width('100%');
		}, 400);
	}

	function adjustViewHide() {
		$(document).scrollTop(initScroll);
	}

	/**
     * When the menu is open we want to make sure all tabbing stays within the dock
     * @params e | Event Object
     */
	function trapFocus(e, scope) {
		var menu = scope.find('[data-menu]'),
			allFocus = menu.find(focusable).filter(':visible'),
			first = allFocus.first(),
			last = allFocus.last(),
			isLast = $(e.target).is(last),
			isFirst = $(e.target).is(first);

		// if last and going forward
		if (isLast && !e.shiftKey) {
			e.preventDefault();
			first.focus();
		}

		// if first and going back
		if (isFirst && e.shiftKey) {
			e.preventDefault();
			last.focus();
		}
	}

	init();
});

/**
 * Modal management
 * Uses materialize modal
 */

DO.Subscribe('app:ready', function(e, $) {
	'use strict';

	var focusable = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]';

	/**
     * Initialize
     */
	function init() {
		setup($(document));
	}

	/**
     * Apply setup to our newly loaded area (document, or scope)
     *
     * @param scope | DOMObject - the area of the page we are applying this functionality to
     */
	function setup(scope) {
		scope.find('[data-modal]').modal(getConfig());
		attachEvents(scope);
	}

	function getConfig() {
		return {
			dismissible: true, // Modal can be dismissed by clicking outside of the modal
			opacity: 0.5, // Opacity of modal background
			inDuration: 300, // Transition in duration
			outDuration: 200, // Transition out duration
			startingTop: '0%', // Starting top style attribute
			endingTop: '0%'
		};
	}

	/**
     * Attach events
     * @param scope | DOMObject
     */
	function attachEvents(scope) {
		scope.find('[data-modal-close]').on('click', function() {
			$(this).modal('close');
			$('body').removeClass('body--modalopen');
		});
		scope.find('[data-modal]').on('click', function(e) {
			$(this).modal('close');
			$('body').removeClass('body--modalopen');
		});

		scope.find('[data-modal-trigger]').on('click', function() {
			var target = $(this).data('target'),
				close = $('#' + target).find('[data-modal-close]');

			$('body').addClass('body--modalopen');

			if (close.length > 0) {
				setTimeout(function() {
					close.focus();
				}, 500);
			}
		});

		scope.find('[data-modalform-replace]').on('click', function(e) {
			e.stopPropagation();
		});

		scope.find(focusable).on('keydown', function(e) {
			var modalParent = $(e.target).closest('.modal');
			if (modalParent.length > 0 && e.which === 9) {
				trapFocus(e, modalParent);
			}
		});

		if (scope.is(document)) {
			$(document).on('ajaxpages:contentloaded', function(e, data) {
				setup(data.target);
			});
		}
	}

	/**
     * When the modal is open we want to make sure all tabbing stays within it
     * @params e | Event Object
     */
	function trapFocus(e, modal) {
		var allFocus = modal.find(focusable).filter(':visible'),
			first = modal.find('[data-modal-close]'),
			last = allFocus.last(),
			isLast = $(e.target).is(last),
			isFirst = $(e.target).is(first);

		// if last and going forward
		if (isLast && !e.shiftKey) {
			e.preventDefault();
			first.focus();
		}

		// if first and going back
		if (isFirst && e.shiftKey) {
			e.preventDefault();
			last.focus();
		}
	}

	init();
});

DO.Subscribe('app:ready', (e, $) => {
	function init() {
		setup($(document));
	}

	function setup(scope) {
		attachEvents(scope);
	}

	function attachEvents(scope) {
		scope.find('[data-search-ajax]').on('click', function(e) {
			e.preventDefault();
			$(this).addClass('loading');
			getMoreResults($(this), scope);
		});

		scope.find('[data-search-filter]').on('click', function(e) {
			e.preventDefault();
			handleFilter($(this), scope);
		});

		scope.find('[data-search-sort]').on('click', function(e) {
			e.preventDefault();
			handleSort($(this), scope);
		});

		if (scope.is(document)) {
			$(document).on('ajaxpages:contentloaded', function(e, data) {
				setup(data.target);
			});
		}
	}

	function handleFilter(self, scope) {
		const parent = scope.find('[data-search-results]');
		addLoader(parent);
		getFilterResults(self, scope);
	}

	function handleSort(self, scope) {
		const parent = scope.find('[data-search-results]');
		self.toggleClass('contentsearch-sortbyitem--active');
		addLoader(parent);
		getSortResults(self, scope);
	}

	function addLoader(targetSelector) {
		var target = $(targetSelector),
			html = ' <span class="loader loader--dark"><span class="loader-text">Loading</span></span>';

		target.html(html).addClass('loading');
	}

	function getMoreResults(target, scope) {
		const sort = scope.find('[data-sort-by]').first(),
			sortFilter = sort.data('sort-by'),
			sortInverse = sort.data('sort-inverse'),
			queryType = 'LoadMore',
			data = {
				ContentFilter: scope.find('.filter-active[data-filter-contentfilter]').data('filter-contentfilter') || 'all',
				ProjectStatusID: scope.find('.filter-active[data-filter-status]').data('filter-status'),
				SortBy: sort.hasClass('contentsearch-sortbyitem--active') ? sortInverse : sortFilter,
				start: scope.find('[data-search-resulttally]').val()
			},
			urlParams = new URLSearchParams(window.location.search);

			// Article Search Page
			if (scope.find('[data-article-type').length) {
				data.article_type = scope.find('[data-article-type]').val();
			}
			if (scope.find('[data-from-date]').length) {
				data.from = scope.find('[data-from-date]').val();
			}
			if (scope.find('[data-to-date]').length) {
				data.to = scope.find('[data-to-date]').val();
			}

			// Forward current URL query params (e.g. DocumentTypeID, TopicID) so the
			// server applies the same filtering as the initial page render.
			urlParams.forEach((value, key) => {
				if (data[key] === undefined || data[key] === null || data[key] === '') {
					data[key] = value;
				}
			});

		makeRequest(target, data, queryType, scope);
	}

	function getFilterResults(self, scope) {
		const contentFilter = self.data('filter-contentfilter'),
			sort = scope.find('[data-sort-by]').first(),
			sortFilter = sort.data('sort-by'),
			sortInverse = sort.data('sort-inverse'),
			queryType = 'Filter';

		clearActive(scope);
		self.addClass('filter-active');

		if (!contentFilter) {
			return false;
		}

		let data = {
			ContentFilter: contentFilter,
			ProjectStatusID: self.data('filter-status'),
			SortBy: sort.hasClass('contentsearch-sortbyitem--active') ? sortInverse : sortFilter,
			start: 0
		};

		makeRequest(self, data, queryType, scope);
	}

	function getSortResults(self, scope) {
		const sortFilter = self.data('sort-by'),
			sortInverse = self.data('sort-inverse'),
			queryType = 'Sort',
			data = {
				ContentFilter: scope.find('.filter-active[data-filter-contentfilter]').data('filter-contentfilter'),
				ProjectStatusID: scope.find('.filter-active[data-filter-status]').data('filter-status'),
				SortBy: self.hasClass('contentsearch-sortbyitem--active') ? sortInverse : sortFilter,
				start: 0
			};

		makeRequest(self, data, queryType, scope);
	}

	function makeRequest(trigger, data, queryType, scope) {
		if (queryType === undefined) {
			showErrorMessage(scope);
			return false;
		}

		data.Keyword = scope.find('[data-search-form-id="search"] [data-search-input]').val();
		data.setsize = scope.find('[data-search-setsize]').val();
		$.ajax({
			url: scope.find('[data-search-url').data('search-url'),
			type: 'GET',
			data: data,
			success(result) {
				hideErrorMessage(scope);
				updateResultTotals(result, data.setsize, data.start, scope);

				if (queryType === 'Sort' || queryType === 'Filter') {
					filterOnSuccess(result, data.setsize, data.start, scope);
				}

				if (queryType === 'LoadMore') {
					onSuccess(result, data.setsize, data.start, scope, trigger);
				}
			}, error() {
				showErrorMessage(scope);
			}
		});
	}

	function updateResultTotals(result, setsize, start, scope) {
		if (typeof setsize === 'undefined') {
			return false;
		}

		let countEndEl = scope.find('[data-resultcount-end]'),
			countTotalEl = scope.find('[data-resultcount-total]'),
			countStartEl = scope.find('[data-resultcount-start]'),

			tallyTotal = parseInt(start, 10) + parseInt(setsize, 10),
			resultCount = tallyTotal > parseInt(result.totalItems, 10) ? result.totalItems : tallyTotal,
			total = parseInt(result.totalItems, 10) > parseInt(resultCount, 10) ? result.totalItems : resultCount;

		countEndEl.text(resultCount);
		countTotalEl.text(total);

		total < 1 ? countStartEl.text('0') : countStartEl.text('1');
	}

	function showErrorMessage(scope) {
		let errorMessage = scope.find('[data-search-error-message');
		errorMessage.text('Sorry, there has been an error').show().attr('aria-hidden', 'false').focus();
	}

	function hideErrorMessage(scope) {
		scope.find('[data-search-error-message').text('').hide().attr('aria-hidden', 'true');
	}

	function onSuccess(result, setsize, start, scope, trigger) {
		const newtallyvalue = parseInt(start, 10) + parseInt(setsize, 10),
			target = scope.find('[data-search-results]'),
			newResults = $(result.ResultsList);

		target.append(newResults);

		// delay fadein for effect
		setTimeout(function() {
			trigger.removeClass('loading');
			checkLoadMore(result.loadmore, scope);
			scope.find('[data-search-resulttally]').val(newtallyvalue);
			$(document).trigger('ajaxpages:contentloaded', {target: newResults});
		}, 1000);
	}

	function filterOnSuccess(result, setsize, start, scope) {
		const target = scope.find('[data-search-results]'),
			newResults = $(result.ResultsList),
			newtallyvalue = parseInt(start, 10) + parseInt(setsize, 10);

		if (!newResults.length) {
			handleEmptyResult(target, scope);
			return;
		}

		setTimeout(function() {
			target.fadeTo(0, 0).html(newResults);
		}, 500);

		// delay fadein for effect
		setTimeout(function() {
			target.fadeTo(1000, 1).removeClass('loading');
			checkLoadMore(result.loadmore, scope);
			scope.find('[data-search-resulttally]').val(newtallyvalue);

			$(document).trigger('ajaxpages:contentloaded', {target: newResults});
		}, 1000);
	}

	function handleEmptyResult(target, scope) {
		let newResults = $('<span class="contentsearch-emptyresult"><span class="contentsearch-emptyresulttext">Sorry &mdash; there are no results with this filter</span></span>');
		setTimeout(function() {
			target.fadeTo(0, 0).html(newResults);
		}, 500);

		// delay fadein for effect
		setTimeout(function() {
			target.fadeTo(1000, 1).removeClass('loading');
			scope.find('[data-search-resulttally]').val(0);
			$(document).trigger('ajaxpages:contentloaded', {target: newResults});
		}, 1000);
	}

	function checkLoadMore(loadmore, scope) {
		const searchajaxbutton = scope.find('[data-search-ajax]');
		loadmore ? searchajaxbutton.show() : searchajaxbutton.hide();
	}

	function clearActive(scope) {
		scope.find('[data-search-filter]').removeClass('filter-active');
		scope.find('[data-search-sort]').removeClass('contentsearch-sortbyitem--active');
	}

	init();
});


DO.Subscribe('app:ready', function(e, $) {
    'use strict';

	function init() {
        if ($(document).find('[data-see-more-button]').length < 1) {
            return;
        }
		attachEvents($(document));
	}
    function attachEvents(scope) {
        $('[data-see-more-button]').on(
            'click',
            function(e) {
                const id = $(this).attr('data-see-more-button');
                $(this).toggleClass('see-more-button--content-hidden');
                $('[data-see-more-content=' + id + ']').slideToggle();
            }
        );
	}

	init();
});

/**
 * Shave is an ellipsis component
 */
DO.Subscribe('app:ready', function(e, $) {
	'use strict';

	function init() {
		setup($(document));

		$(window).on('resize', function() {
			setup($(document));
		});
	}

	function setup(scope) {
		if (scope.find('[data-shave]').length < 1) {
			return;
		}
		attachShave(scope);
		attachEvents(scope);
	}

	function attachShave(scope) {
		var targets = scope.find('[data-shave]'),
			i;

		for (i = 0; i < targets.length; i++) {
			applyShave($(targets[i]));
		}
	}

	function applyShave(target) {
		var maxheight = target.outerHeight() + 1;

		if (!maxheight) {
			maxheight = 100;
		}
		target.shave(maxheight);
	}

	function attachEvents(scope) {
		if (scope.is(document)) {
			DO.Subscribe(
				['app:breakpointchange'],
				function(e) {
					attachShave(scope);
				}
			);

			$(document).on('ajaxpages:contentloaded', function(e, data) {
				setup(data.target);
			});

			scope.on('togglecontent:replaced', function() {
				attachShave(scope);
			});
		}
	}

	init();
});

/**
* Slick slider init
*
*/
DO.Subscribe('app:ready', function(e, $) {
	'use strict';

	function init() {
		setup($(document));
	}

	function setup(scope) {
		if (scope.find('[data-slider]').length < 1) {
			return;
		}

		var target = scope.find('[data-slider]'),
			i;

		for (i = 0; i < target.length; i++) {
			attachSlider($(target[i]));
		}

		attachEvents(scope);
	}

	/**
	 * Attaches the bulma carousel to an individual slider target
	 * @param target
	 */
	function attachSlider(target) {
		target.slick(getConfig(target));
	}

	function attachEvents(scope) {
		if (scope.is(document)) {
			$(document).on('ajaxpages:contentloaded', function(e, data) {
				setup(data.target);
			});

			scope.find('[data-slide-control-left]').on('click', function(e) {
				e.preventDefault();
				slideLeft($(this));
			});

			scope.find('[data-slide-control-right]').on('click', function(e) {
				e.preventDefault();
				slideRight($(this));
			});
		}
	}

	function getConfig(target) {
		var showArrows = !target.data('no-controls');
		return {
			mobileFirst: true,
			variableWidth: true,
			infinite: false,
			swipe: true,
			arrows: showArrows,
			prevArrow: showArrows ? getPrevArrow() : false,
			nextArrow: showArrows ? getNextArrow() : false,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToScroll: 3
					}
				}
			]
		};
	}

	function getNextArrow(target) {
		return '<button type="button" class="pure-button pure-button-icononly slick-next"><span class="sr-only">Next</span></button>';
	}

	function getPrevArrow(target) {
		return '<button type="button" class="pure-button pure-button-icononly slick-prev"><span class="sr-only">Previous</span></button>';
	}

	function slideLeft(target) {
		const slider = target.closest('[data-slider-wrapper]')[0].querySelector('[data-slider]');
		$(slider).slick('slickPrev');
	}

	function slideRight(target) {
		const slider = target.closest('[data-slider-wrapper]')[0].querySelector('[data-slider]');
		$(slider).slick('slickNext');
	}

	init();
});


/**
 * Ccomponent to adjust sticky/stuck state
 */
DO.Subscribe('app:ready', function(e, $) {
	'use strict';

	function init() {
		setup($(document));
	}

	function setup(scope) {
		if (scope.find('[data-sticky]').length < 1) {
			return;
		}

		var sticky = scope.find('[data-sticky]'),
			i;

		for (i = 0; i < sticky.length; i++) {
			attachStuck(sticky[i]);
		}

		attachEvents(scope);
	}

	function attachStuck(el) {
		var stickyClass = $(el).data('sticky'),
			observer = new IntersectionObserver(
				([e]) => e.target.classList.toggle(stickyClass, e.intersectionRatio < 1),
				{
					rootMargin: '-1px 0px 0px 0px',
					threshold: [1]
				});

		observer.observe(el);
	}

	function attachEvents(scope) {
		if (scope.is(document)) {
			$(document).on('ajaxpages:contentloaded', function(e, data) {
				setup(data.target);
			});
		}
	}

	init();
});


/**
 * Component to handle oversized and responsive tables
 */

DO.Subscribe('app:ready', function(e, $) {
	'use strict';

	function init() {
		setup($(document));

		// do this here because every other event relies on tables existing at page load
		$(document).on('ajaxpages:contentloaded', function(e, data) {
			setup(data.target);
		});
	}

	function setup(scope) {
		if (scope.find('table').not('[data-fullpage]').length > 0) {
			markupTable(scope.find('table').not('[data-fullpage]'));// do once
			attachEvents(scope); // do once for each scope
			tableView(scope); // do every time we resize
		}

		if (scope.find('table tfoot').length > 0) {
			var i,
				target = scope.find('table tfoot');

			for (i = 0; i < target.length; i = i + 1) {
				footOddEven($(target[i]).closest('table'));
			}
		}
	}
	/**
     * Continue the odd/even count from the tbody into the tfoot
     * Note: applies the the first row only - but the rest can be done with css if needed
     *
     * @param table | DOMElement
     */
	function footOddEven(table) {
		var rowsCount = table.find('tbody tr').length,
			oddEven = rowsCount % 2 === 0 ? 'odd' : 'even';

		table.find('tfoot tr').addClass(oddEven);
	}

	/**
     * Attach event listeners
     */
	function attachEvents(scope) {
		handleScroll(scope);
		handleClick(scope);

		// do once
		if (scope.is(document)) {
			handleResize();
			scope.on('togglecontent:replaced', function() {
				tableView();
			});
		}
	}

	function handleClick(scope) {
		scope.find('[data-table-indicator]').on('click', function() {
			var wrapper = $(this).siblings('[data-table-wrapper]'),
				scroll = wrapper.scrollLeft();

			if ($(this).hasClass('table-indicator--right')) {
				wrapper.animate({scrollLeft: scroll + 200}, 200);
			} else {
				wrapper.animate({scrollLeft: scroll - 200}, 200);
			}
		});
	}

	/**
     * Wrap tables and inject indicator elements to allow for large table scrolling
     */
	function markupTable(table) {
		table.not('[data-table-collapsed]').wrap('<div data-table-wrapper class="table-wrapper"></div>');
		table.closest('[data-table-wrapper]').wrap('<div data-table-outer class="table-outer"></div>');
		table.closest('[data-table-outer]').append(
			'<button data-table-indicator="left" class="table-indicator table-indicator--left">' +
            '<span class="sr-only">Scroll table left</span>' +
            '</button>'
		);
		table.closest('[data-table-outer]').append(
			'<button data-table-indicator="right" class="table-indicator table-indicator--right">' +
            '<span class="sr-only">Scroll table right</span>' +
            '</button>'
		);
	}

	/**
     * Function to listen to resize event,
     * Makes sure the event firing is throttled  to every half second
     * so performance isn't hurt too much
     */
	function handleResize() {
		var resize;

		$(window).on('resize', function(event) {
			resize = true;
		});

		setInterval(function() {
			if (resize) {
				tableView();
				resize = false;
			}
		}, 500);
	}

	/**
     * When a table wrapper is scrolled to the end, the right scroll indicator should
     * disappear. When the table is scrolled from the start, the left arrow should appear.
     * These elements are hidden by default and show when either the .table-wrapper--left  or
     * .table-wrapper--right classes are present on table-wrapper
     */
	function handleScroll(scope) {
		var fromend = false,
			fromstart = true;

		scope.find('[data-table-wrapper]').on('scroll', function(e) {
			var elem = $(e.currentTarget),
				width = $(this).find('table').width(),
				scrollLeft = $(elem).scrollLeft(),
				scrollEnd = scrollLeft + $(this).width();

			// handle scroll to end
			if (scrollEnd >= (width - 20)) { // allow for a 20px difference for mobile
				$(this).removeClass('table-wrapper--right');
				$(this).siblings('[data-table-indicator="left"]').focus();
				fromend = true;
			} else if (fromend) {
				$(this).addClass('table-wrapper--right');
				fromend = false;
			}

			// handle scroll from start
			if (scrollLeft <= 0) {
				$(this).removeClass('table-wrapper--left');
				$(this).siblings('[data-table-indicator="right"]').focus();
				fromstart = true;
			} else if (fromstart) {
				$(this).addClass('table-wrapper--left');
				fromstart = false;
			}
		});
	}

	/**
     * Adjust visual display of markers to fit their tables, and add and remove
     * table-active class
     */
	function tableView() {
		var tableOuter = $('[data-table-outer]'),
			i;

		for (i = 0; i < tableOuter.length; i = i + 1) {
			hasOverflow($(tableOuter[i]).find('[data-table-wrapper]'));
			adjustMarkerHeight($(tableOuter[i]));
		}
	}

	/**
     * Fit the marker to sit between the header and the last row
     */
	function adjustMarkerHeight(tableWrapper) {
		var target = tableWrapper.find('[data-table-indicator]'),
			head = tableWrapper.find('thead tr:first-child'),
			top = head.length > 0 ? head.outerHeight() + 1 : 0,
			lastChild = tableWrapper.find('table tbody'),
			bottom = lastChild.position().top + lastChild.outerHeight();

		target.css({'height': bottom - top + 1, 'top': top});
	}

	/**
     * Check if table end is outside bounds. If it is, add the active class.
     * If it isn't, remove the active class.
     */
	function hasOverflow(tableWrapper) {
		var wrapWidth = tableWrapper.width(),
			width = tableWrapper.find('table').width();

		if (wrapWidth < width) {
			tableWrapper.addClass('table-active table-wrapper--right');
		} else {
			tableWrapper.removeClass('table-active');
		}
	}

	init();
});

/**
 * Tabbed ajax loaded navigation component
 */
DO.Subscribe('app:ready', function(e, $) {
	'use strict';

	function init() {
		setup($(document));
	}

	function setup(scope) {
		if (scope.find('[data-tabnav-list]').length < 1) {
			return;
		}
		tabnavView(scope); // do every time we resize
		attachEvents(scope);
	}

	function attachEvents(scope) {
		handleScroll(scope);
		attachIndicatorClick(scope);

		scope.find('[data-tabnav-list] a').on('click', function(e) {
			e.preventDefault();
			handleTabChange($(this));
		});

		if (scope.is(document)) {
			handleResize();
			$(document).on('ajaxpages:contentloaded', function(e, data) {
				setup(data.target);
			});
		}
	}

	function attachIndicatorClick(scope) {
		scope.find('[data-tabnav-indicator]').on('click', function() {
			var wrap = $(this).siblings('[data-tabnav-wrap]'),
				scroll = wrap.scrollLeft();

			if ($(this).data('tabnav-indicator') === 'right') {
				wrap.animate({scrollLeft: scroll + 200}, 200);
			} else {
				wrap.animate({scrollLeft: scroll - 200}, 200);
			}
		});
	}

	/**
     * Function to listen to resize event,
     * Makes sure the event firing is throttled  to every half second
     * so performance isn't hurt too much
     */
	function handleResize() {
		var resize;

		$(window).on('resize', function(event) {
			resize = true;
		});

		setInterval(function() {
			if (resize) {
				tabnavView();
				resize = false;
			}
		}, 500);
	}

	function handleTabChange(self) {
		addLoader(self.data('target'));
		self.closest('[data-tabnav-list]').find('a').removeClass('active');
		makeRequest(self.attr('data-href'), self.data('target'));
		self.addClass('active');
		pushHistory(self.attr('data-href'));
	}

	/**
     * Track our pages as if they were real links
     * @param url | String
     */
	function pushHistory(url) {
		var newURL = url.replace(/inner/g, '');
		history.pushState({url: newURL, type: 'tabnav'}, 'tabnav', newURL);
	}

	function addLoader(targetSelector) {
		var target = $(targetSelector),
			html = ' <span class="loader loader--dark"><span class="loader-text">Loading</span></span>';

		target.html(html);
	}

	/**
     * Request a page form the url supplied
     * @param url | string
     * @param target
     */
	function makeRequest(url, target) {
		$.ajax({
			type: 'GET',
			url: url,
			cache: true,
			success: function(data, status) {
				// handle success
				updateTab(data, url, target);
			},
			error: function (xhr, desc, err) {
				var response = xhr.responseText,
					html = $(response.substring(response.indexOf('<body>')));

				updateTab(html, url, target);
			}
		});
	}

	/**
     * Handles the content updates for the dock, and any animation effects
     * @param content | HTML
     * @param url | String
     * @param targetSelector | String
     */
	function updateTab(content, url, targetSelector) {
		var target = $(targetSelector);
		target.attr('data-url', url);

		// delay fadein for effect
		setTimeout(function() {
			target.fadeOut(0).html(content);
		}, 500);

		// delay fadein for effect
		setTimeout(function() {
			target.fadeIn(1000);
			$(document).trigger('ajaxpages:contentloaded', {target: target});
		}, 1000);
	}

	/**
     * When a tabnav is scrolled to the end, the right scroll indicator should
     * disappear. When the tabnav is scrolled from the start, the left arrow should appear.
     * These elements are hidden by default and show when either the .tabnav-wrap--left  or
     * .tabnav-wrap--right classes are present on tabnav-wrap
     */
	function handleScroll(scope) {
		var fromend = false,
			fromstart = true;

		scope.find('[data-tabnav-wrap]').on('scroll', function(e) {
			var elem = $(e.currentTarget),
				width = getTabnavWidth($(this)),
				offset = getTabnavOffset($(this)),
				scrollLeft = $(elem).scrollLeft(),
				scrollEnd = scrollLeft + $(this).width();

			// handle scroll to end (show right button)
			if (scrollEnd >= width) {
				$(this).removeClass('tabnav-wrap--right');
				$(this).siblings('[data-tabnav-indicator="left"]').focus();
				fromend = true;
			} else if (fromend) {
				$(this).addClass('tabnav-wrap--right');
				fromend = false;
			}

			// handle scroll from start (show left button)
			if (scrollLeft <= offset) {
				$(this).removeClass('tabnav-wrap--left');
				$(this).siblings('[data-tabnav-indicator="right"]').focus();
				fromstart = true;
			} else if (fromstart) {
				$(this).addClass('tabnav-wrap--left');
				fromstart = false;
			}
		});
	}

	/**
     * Adjust visual display of markers to fit, and add and remove
     * tabnav-active class
     */
	function tabnavView() {
		var tabnavOuter = $('[data-tabnav-outer]'),
			i;

		for (i = 0; i < tabnavOuter.length; i = i + 1) {
			hasOverflow($(tabnavOuter[i]).find('[data-tabnav-wrap]'));
		}
	}

	function getTabnavWidth(tabnavWrap) {
		var width = tabnavWrap.find('[data-tabnav-list]').width();
		return width + getTabnavOffset(tabnavWrap);
	}

	/**
     * Note: to measure offset, we must use a container outside the tabnav
     * @param tabnavWrap
     */
	function getTabnavOffset(tabnavWrap) {
		return tabnavWrap.siblings('[data-tabnav-measure]').offset().left;
	}

	/**
     * Check if tabnav end is outside bounds. If it is, add the active class.
     * If it isn't, remove the active class.
     */
	function hasOverflow(tabnavWrap) {
		var wrapWidth = tabnavWrap.width(),
			width = getTabnavWidth(tabnavWrap);

		if (wrapWidth < width) {
			tabnavWrap.addClass('tabnav-active tabnav-wrap--right');
		} else {
			tabnavWrap.removeClass('tabnav-active');
		}
	}

	init();
});

/**
 * Toggles and switches extra js (for accessibility).
 * Uses ../lib/toggles-switches.js from https://github.com/dsurgeons/Toggles-Switches
 */

DO.Subscribe('app:ready', function(e, $) {
	'use strict';

	var focusable = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]',
		focusableNative = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed';

	/**
	 * Initialize Button actions
	 */
	function init() {
		setup($(document));
	}

	/**
	 * Apply setup to our newly loaded area (document, or scope)
	 *
	 * @param scope | DOMObject - the area of the page we are applying this functionality to
	 */
	function setup(scope) {
		// if aria hidden, we shouldn't be able to focus. Skip userform steps
		scope.find('[aria-hidden="true"]:not(.userformsstep)').find(focusable).attr('tabindex', '-1');

		attachEvents(scope);
	}

	/**
	 * If an element has the attribute data-toggle-aria we want to toggle the
	 * aria-hidden attribute of the data-toggle-aria value and the tabindex of
	 * all focusable children.
	 * @param scope | DOMObject
	 */
	function attachAriaHide(scope) {
		var targets = scope.find('[data-toggle-aria]');

		// Set aria hidden and tabindex -1
		targets.on('click', function() {
			var target = $(this).data('toggle-aria'),
				value = $(target).attr('aria-hidden') === 'false' ? 'true' : 'false',
				tabindex = value === 'false' ? '0' : '-1';

			$(target).attr('aria-hidden', value);
			$(target).find(focusable).attr('tabindex', tabindex);
		});
	}

	/**
	 * Attach events
	 * @param scope | DOMObject
	 */
	function attachEvents(scope) {
		attachAriaHide(scope);

		scope.find('[data-contain]').on('click', function(e) {
			e.stopPropagation();
		});

		scope.find('[data-trigger-click]').on('click', function(e) {
			var target = $(this).data('trigger-click');
			$(target).trigger('click');
		});

		attachWatcher();

		// make sure we get the order of our events right
		setTimeout(function() {
			keyboardFocus(scope);
		}, 1000);

		if (scope.is(document)) {
			$(document).on('ajaxpages:contentloaded', function(e, data) {
				setup(data.target);
			});
		}
	}

	function attachWatcher() {
		var toggles = $('[data-toggle-replace]'),
			i;

		for (i = 0; i < toggles.length; i++) {
			toggles[i].addEventListener('ToggleSwitch.replaced', function() {
				$(document).trigger('togglecontent:replaced', {target: this});
			});
		}
	}

	/**
	 * Allow a focus state that only appears for people using keyboards to navigate
	 * @param scope | DOMObject
	 */
	function keyboardFocus(scope) {
		scope.find(focusable).on('keyup', function(e) {
			$(e.target).addClass('hasfocus');

			if ($(e.target).is(focusableNative)) {
				return;
			}

			// trigger click if this element doesn't usually support click
			if (e.keyCode === 13) {
				e.preventDefault();
				e.stopPropagation();
				$(e.target).trigger('click');
			}
		}).on('blur focusout', function(e) {
			$(e.target).removeClass('hasfocus');
		});
	}

	init();
});
